import React, { memo, useMemo, useRef, useState, useCallback, useEffect } from 'react'
import { Link } from '@reach/router'
import { Hidden, IconButton } from '@material-ui/core'
import { listLogin } from '../../shared/constants/links'
import { ReactComponent as Whatsapp } from '../../assets/svgs/whatsapp.svg'
import { ReactComponent as Instagram } from '../../assets/svgs/insta.svg'
import { ReactComponent as FacebookBox } from '../../assets/svgs/fb.svg'
import * as Styled from './styled'
import useBreakpoints from '../../hooks/useBreakpoints'
import getParams from '../../shared/utils/getParams'
import Popover from '../Popover'

const Topbar = () => {
  const { isDesk } = useBreakpoints()
  const loginButton = useRef()
  const [open, setOpen] = useState(false)
  const WhatsappIconSize = useMemo(() => (isDesk ? '20px' : '27px'), [isDesk])

  return (
      <Hidden mdDown>
    <Styled.TopHeader>
      <Styled.TopContent>

        <Styled.LinkList style={{width: 770, justifyContent: 'flex-end'}}>
          
          <Styled.Item padding='0 10px'>
            <Styled.NavButton
              size='small'
              color='primary'
              variant='outlined'
              component='a'
              id='minhaWDentalLink'
              href='https://minha.w.dental'
              rel='noopener noreferrer'
            >
              2° Via de Boleto
            </Styled.NavButton>
          </Styled.Item>

          <Styled.Item padding='0 10px'>
            <Styled.NavButton
              size='small'
              color='primary'
              variant='outlined'
              ref={loginButton}
              id='loginHeaderButton'
              onClick={() => setOpen(true)}
            >
              Login
            </Styled.NavButton>
          </Styled.Item>

          <Styled.Item padding='0'>
            <IconButton
              disableRipple
              className='noHoverBg'
              size='small'
              edge='end'
              color='inherit'
              aria-label='Acessar o Instagram da W.Dental'
            >
              <a
                href='https://www.instagram.com/w.dental_br/'
                rel='noopener noreferrer'
                target='_blank'
              >
                <Instagram
                  style={{ marginRight: 16, height: '20px', width: '20px' }}
                />
              </a>
            </IconButton>
          </Styled.Item>

          <Styled.Item padding='0'> 
            <IconButton
              disableRipple
              className='noHoverBg'
              size='small'
              edge='end'
              color='inherit'
              aria-label='Acessar o Facebook da W.Dental'
            >
              <a
                href='https://www.facebook.com/W.Dental.br/'
                rel='noopener noreferrer'
                target='_blank'
              >
                <FacebookBox
                  style={{ marginRight: 16, height: '20px', width: '20px' }}
                />
              </a>
            </IconButton>
          </Styled.Item>

          <Styled.Item padding='0'> 
            <IconButton
              disableRipple
              className='noHoverBg'
              size='small'
              edge='end'
              color='inherit'
              aria-label='Enviar mensagem via whatsapp'
            >
              <a
                href='https://wa.me/5521970646570'
                rel='noopener noreferrer'
                target='_blank'
              >
                <Whatsapp
                  style={{
                    height: WhatsappIconSize,
                    width: WhatsappIconSize
                  }}
                />
              </a>
            </IconButton>
          </Styled.Item>

        </Styled.LinkList>
     
      <Popover
          anchorEl={loginButton}
          open={open}
          onClose={() => setOpen(false)}
        >
          {listLogin.map(({ title, route, link }) =>
            Boolean(route) ? (
              <Styled.InternalLink to={route} key={`internalLink${title}`}>
                {title}
              </Styled.InternalLink>
            ) : (
              <Styled.ExternalLink
                key={`externalLink${title}`}
                rel='noopener noreferrer'
                href={link}
              >
                {title}
              </Styled.ExternalLink>
            )
          )}
        </Popover>
      </Styled.TopContent>
    </Styled.TopHeader>
    </Hidden>

  )
}

export default memo(Topbar)